import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ViewClientSpecificContentWrapper = styled.div`
  .accordion-resource-header {
    margin-bottom: 24px !important;
    ${responsive.MOBILE`
      margin-bottom: 16px !important;
    `}
  }

  .view-country-dropdown {
    label {
      margin-bottom: 0px;
    }
  }

  .group-name-container {
    padding: 24px 16px;
    border-top: 1px solid ${COLORS.cirrus_black3};
    border-bottom: 1px solid ${COLORS.cirrus_black3};
    ${responsive.MOBILE`
      padding: 16px 16px;
      width: 100%;
      input {
        width: 100%;
      }
    `}
  }

  .MuiGrid2-root {
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 0;
        }
    `}
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    padding: 24px 16px 0px;
    ${responsive.MOBILE`
      padding: 16px 16px 0;
    `}
  }
`;
